import api, { request } from '../../../../api';
import { IStore } from '../../../';

export const getDetailGames = async (
  state: IStore,
  clubId: number,
  eventId: number,
  roundId: number,
  // @ts-ignore
  force?: boolean
) => {
  const response = await request.get(`${api.admin.detailGames(clubId, eventId, roundId)}`);

  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving Detail Games' } } };
  }

  return state;
};
